import { useStoredData } from "@/store";
import { useMemo } from "react";

export default function useIsErc20Withdrawal() {
  const storedData = useStoredData();

  return useMemo(() => storedData.withdrawCart.find(cartItem => cartItem.is_erc20) !== undefined, [storedData.withdrawCart]);
}
